import { render, staticRenderFns } from "./sentList.vue?vue&type=template&id=1368824f&scoped=true&"
import script from "./sentList.vue?vue&type=script&lang=js&"
export * from "./sentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368824f",
  null
  
)

export default component.exports